import { FormikProps } from "formik"
import React, { useEffect, useState } from "react"
import { FormGroup, Col, Label, Input, FormFeedback } from "reactstrap"
import { useSelector } from "react-redux"
import { RootState } from "store"
import { OWNER_ROLE_SLUG, UserBrand, UserRole } from "types/users"
import RadioGroup from "Components/input/RadioGroup/RadioGroup"
import UserPrivileges from "./UserPrivileges"
import UserIcon from "assets/icons/UserIcon"
import EmailIcon from "assets/icons/EmailIcon"
import StarIcon from "assets/icons/StarIcon"
import SpeechBubbleIcon from "assets/icons/SpeechBubleIcon"
import FieldInstruction from "Components/Common/FieldInstruction"
import { FIELDS_INSTRUCTIONS } from "constants/fieldsInstructions"
import CustomMultiSelect from "Components/Common/CustomMultiSelect"
import CheckboxGroup from "Components/input/CheckboxGroup/CheckboxGroup"

export interface UserFormValues {
    name: string,
    email: string,
    role: UserRole,
    brands: UserBrand[],
    notification_preferences: string[]

}
const Fields: React.FC<{ formFields: FormikProps<UserFormValues>, onRoleChange: (userRole: UserRole) => void, editMode?: boolean }> = ({ formFields, onRoleChange, editMode = false }) => {

    const roles = useSelector((state: RootState) => state.roles.items);
    const userBrands = useSelector((state: RootState) => state.userBrands.items);

    const notificationPreferences = useSelector((state: RootState) => state.master.configurations.notification_preferences);

    const [selectedRole, setSelectedRole] = useState<UserRole | null>(null);


    useEffect(() => {
        const selected_role = roles.find((role) => role.slug === formFields.values.role.slug);
        setSelectedRole(selected_role ?? null);
    }, [roles, formFields.values.role])

    useEffect(() => {
        onRoleChange(selectedRole!);
    }, [selectedRole])

    return (
        <React.Fragment>
            <FormGroup row className='py-4 mt-3'>
                <Col sm={4} className='my-1'>
                    <div className="d-flex gap-3">
                        <div className="w-40px">
                            <UserIcon className='me-2' />
                        </div>
                        <div className="d-flex flex-column gap-2">
                            <Label htmlFor='name' className='form-label input-label mb-0'>
                                User's Name <span className="text-danger">*</span>
                            </Label>
                            <FieldInstruction instruction={FIELDS_INSTRUCTIONS.USER.NAME} />
                        </div>
                    </div>
                </Col>
                <Col sm={8} className='my-1'>
                    <Input
                        type='text'
                        name='name'
                        className='form-control'
                        onChange={formFields.handleChange}
                        onBlur={formFields.handleBlur}
                        value={formFields.values.name || ""}
                        invalid={formFields.touched.name && formFields.errors.name ? true : false}
                        disabled={editMode}
                        placeholder='Enter Name' />
                    {
                        formFields.touched.name && formFields.errors.name &&
                        <FormFeedback type="invalid">
                            {formFields.errors.name}
                        </FormFeedback>
                    }
                </Col>
            </FormGroup>
            <div className="divider"></div>
            <FormGroup row className='py-4 mt-3'>
                <Col sm={4} className='my-1'>
                    <div className="d-flex gap-3">
                        <div className="w-40px">
                            <EmailIcon className='me-2' />
                        </div>
                        <div className="d-flex flex-column gap-2">
                            <Label htmlFor='name' className='form-label input-label mb-0'>
                                User's Email <span className="text-danger">*</span>
                            </Label>
                            <FieldInstruction instruction={FIELDS_INSTRUCTIONS.USER.EMAIL} />
                        </div>
                    </div>
                </Col>
                <Col sm={8} className='my-1'>
                    <Input
                        type='text'
                        name='email'
                        className='form-control'
                        onChange={formFields.handleChange}
                        onBlur={formFields.handleBlur}
                        value={formFields.values.email || ""}
                        invalid={formFields.touched.email && formFields.errors.email ? true : false}
                        disabled={editMode}
                        placeholder='Enter Email ID' />
                    {
                        formFields.touched.email && formFields.errors.email &&
                        <FormFeedback type="invalid">
                            {formFields.errors.email}
                        </FormFeedback>
                    }
                </Col>
            </FormGroup>
            <div className="divider"></div>
            <FormGroup row className='py-4 mt-3'>
                <Col sm={4} className='my-1'>
                    <div className="d-flex gap-3">
                        <div className="w-40px">
                            <SpeechBubbleIcon className='me-2' />
                        </div>
                        <div className="d-flex flex-column gap-2">
                            <Label htmlFor='name' className='form-label input-label mb-0'>
                                User's Role <span className="text-danger">*</span>
                            </Label>
                            <FieldInstruction instruction={FIELDS_INSTRUCTIONS.USER.ROLE} />
                        </div>
                    </div>
                </Col>
                <Col sm={8} className='my-1'>

                    <RadioGroup
                        name="role"
                        options={roles.map((role) => ({ id: role.slug, label: role.name }))}
                        defaultValue={formFields.values.role.slug}
                        onChange={(selectedRoleSlug) => {
                            formFields.setFieldValue('role', roles.find((role) => role.slug === selectedRoleSlug))
                        }}
                    />

                    {
                        selectedRole &&
                        <UserPrivileges privileges={selectedRole.privileges ?? []} />
                    }
                </Col>
            </FormGroup>
            {
                formFields.values.role.slug !== OWNER_ROLE_SLUG &&
                <React.Fragment>
                    {/* <div className="divider"></div>
                    <FormGroup row className='py-4 mt-3'>
                        <Col sm={4} className='my-1'>
                            <div className="d-flex gap-3">
                                <div className="w-40px">
                                    <StarIcon className='me-2' />
                                </div>
                                <div className="d-flex flex-column gap-2">
                                    <Label htmlFor='name' className='form-label input-label mb-0'>
                                        Brands <span className="text-danger">*</span>
                                    </Label>
                                    <FieldInstruction instruction={FIELDS_INSTRUCTIONS.USER.BRANDS} />
                                </div>
                            </div>
                        </Col>
                        <Col sm={8} className='my-1'>
                            <CustomMultiSelect
                                isMulti
                                name="brands"
                                placeholder="Select Brands"
                                values={(formFields.values.brands ?? []).map((ub) => ub.id)}
                                options={userBrands.map((ub) => ({ label: ub.name, value: ub.id }))}
                                styles={{
                                    multiValueLabel: (base: any) => {
                                        return { ...base, color: "white" }
                                    }
                                }}
                                onChange={(selected) => {
                                    let selectedBrands: UserBrand[]= [];
                                    if (Array.isArray(selected)) {
                                       selectedBrands = userBrands.filter((ub) => selected.includes(ub.id));
                                    }
                                    formFields.setFieldValue('brands', selectedBrands);
                                }}
                                onBlur={() => formFields.setFieldTouched('brands', true)}
                            />
                            {
                                formFields.touched.brands && formFields.errors.brands &&
                                <FormFeedback type="invalid" className="d-block">
                                    {Array.isArray(formFields.errors.brands) ? formFields.errors.brands.join(', ') : formFields.errors.brands}
                                </FormFeedback>
                            }
                        </Col>
                    </FormGroup> */}
                </React.Fragment>
            }
            <FormGroup row className='py-4 mt-3'>
                <Col sm={4} className='my-1'>
                    <div className="d-flex gap-3">
                        <div className="w-40px">
                            <EmailIcon className='me-2' />
                        </div>
                        <div className="d-flex flex-column gap-2">
                            <Label htmlFor='name' className='form-label input-label mb-0'>
                             Notification Preferences
                            </Label>
                            <FieldInstruction instruction={FIELDS_INSTRUCTIONS.USER.NOTIFICATION_PREFERENCES} />
                        </div>
                    </div>
                </Col>
                <Col sm={8} className='my-1'>
                    <CheckboxGroup 
                        options={notificationPreferences ? notificationPreferences.map((pref) => ({label: pref.label, value: pref.key})) : []}
                        selectedValues={formFields.values.notification_preferences ?? []}
                        onChange={(selected) => formFields.setFieldValue('notification_preferences', selected)}
                    />
                    {
                        formFields.touched.notification_preferences && formFields.errors.notification_preferences &&
                        <FormFeedback type="invalid">
                            {formFields.errors.notification_preferences}
                        </FormFeedback>
                    }
                </Col>
            </FormGroup>
            <div className="divider"></div>
        </React.Fragment>
    )
}

export default Fields